import React from 'react'
import styled from 'styled-components'
import { useWindowDimensions } from '@sentecacommerce-theme/lib'
import { useStoresContext } from '../stores.context'
import { SingleStore } from '../stores.props'
import { StoresMap } from './StoresMap'
import { ModalProps } from '../../Common'
import dynamic from 'next/dynamic'

const Modal = dynamic<ModalProps>(
  () => import('../../Common/Modal').then((mod) => mod.Modal),
  {
    ssr: false,
  }
)

export const StoreList = ({
  pinIcon,
  renderStore,
}: {
  pinIcon: string
  renderStore: (store: SingleStore) => JSX.Element
}) => {
  const { stores, selectedStore, reset } = useStoresContext()

  const { width } = useWindowDimensions()

  const isModalVisible = Boolean(selectedStore) && width < 768

  return (
    <List>
      {isModalVisible && (
        <Modal
          open={isModalVisible}
          handleClose={reset}
          noContentPadding
          noTitlePadding
          fullOnMobile
          circleClose
        >
          <ModalMapContainer>
            <StoresMap fullWidth pinIcon={pinIcon} />
          </ModalMapContainer>
        </Modal>
      )}
      {stores.map((store) => (
        <ListItem
          id={`Store_${store.latitude}x${store.longitude}`}
          key={`Store_${store.latitude}x${store.longitude}`}
        >
          {renderStore(store)}
        </ListItem>
      ))}
    </List>
  )
}

const List = styled.ul``

const ListItem = styled.li.attrs({
  className: 'pb-3 mb-3',
})`
  border-bottom: 0.1rem solid ${({ theme }) => theme.palette.panache};
`

const ModalMapContainer = styled.div.attrs({
  className: 'mt-5 pt-5',
})`
  position: relative;
`
